import axios from 'axios';
import {setLoaderVisibility} from './commonredux/commonRedux.action';
import {store} from '../store/store';
import {logout} from './logOut';
import asyncStorage from '@react-native-async-storage/async-storage/src/AsyncStorage';
import {getTimeZone} from 'react-native-localize';
import {isLogEnabled, REACT_APP_ENV} from '../../index';
import {Platform} from 'react-native';
import {globalConst} from './globalConstant';
import {getCurrentRoute} from '../navigation/rootNavigation';
import {CONTEST_EVENTS} from './apiUrl';
import {globalImport} from '../common/globalImports';
import {trackMoengageEvent} from './commonMethods';

const configuration = {
  headers: {
    'Content-Type': 'application/json',
    'x-platform':
      Platform.OS === 'web'
        ? 'web'
        : Platform.OS === 'android'
        ? 'android'
        : 'ios',
    'Cache-Control': 'no-cache',
    'x-user-timezone': getTimeZone(),
    'x-partner-id': globalImport?.PARTNER_ID ? +globalImport?.PARTNER_ID : 1,
    version: 2001,
  },
};

const instance = axios.create(configuration);

export const headerSet = token => {
  delete instance.defaults.headers.common.Authorization;
  instance.defaults.headers.common.Authorization = token;
};

export const headerSetPartner = token => {
  delete instance.defaults.headers['x-partner-id'];
  instance.defaults.headers['x-partner-id'] = token;
};

const requestHandler = request => {
  //console.log(request);
  return request;
};

instance.interceptors.request.use(request => requestHandler(request));

const logApi = (method, url, body = '', response) => {
  if (REACT_APP_ENV !== 'prod' && isLogEnabled) {
    console.log(
      `${method} URL : ${url}\nHEADERS: `,
      body,
      '\nRESPONSE: ',
      response?.data,
    );
  }
};

const logAPIError = (method, url, body = '', err) => {
  if (REACT_APP_ENV !== 'prod' && isLogEnabled) {
    console.log(
      `ERROR - ${method} URL : ${url}\nHEADERS: `,
      body,
      '\nRESPONSE: ',
      err.message,
    );
  }
};

const getRoute = url => {
  const currRoute =
    Platform.OS !== 'web' ? getCurrentRoute() : window?.location?.pathname;
  if (
    (currRoute.includes('ContestEvents') ||
      currRoute.includes('ContestPortfolio') ||
      currRoute.includes('contestDetail') ||
      currRoute.includes('Fantasy')) &&
    !currRoute.includes('/Fantasy/Tokens')
  ) {
    if (url.includes('getProbes')) {
      return CONTEST_EVENTS;
    }
    var v2Index = url.indexOf('v2');
    var txt2 = url.slice(0, v2Index + 3) + 'fantasy/' + url.slice(v2Index + 3);
    return txt2;
  }

  return url;
};

const GET = async (URL, options, isCheckRoute = false) => {
  //const logedIn = await asyncStorage.getItem('userMobNumber');
  let _URL = URL;
  if (isCheckRoute) {
    _URL = getRoute(_URL);
  }
  if (
    !instance?.defaults?.headers?.common?.Authorization &&
    _URL.includes('get_updated_prices') &&
    !globalImport.isWeb
  ) {
    trackMoengageEvent('updatePriceApi', {
      headers: instance?.defaults?.headers?.common?.Authorization
        ? true
        : false,
    });
  }
  const response = await instance.get(_URL, options).catch(function (err) {
    if (err.response?.status === 401) {
      // const isLogin = instance?.defaults?.headers?.common?.Authorization;
      // if (isLogin && !globalImport.isWeb) {
      //   // trackMoengageEvent('Logout Issue', {
      //   //   URL: URL,
      //   // });
      //   // globalImport?.sentry?.captureException(new Error(URL));
      // }
      logout();
    }
    logAPIError('GET', _URL, options, err);
    return err.response;
  });
  logApi('GET', _URL, options, response);
  return response;
};

const POST = async (
  URL,
  data = null,
  options,
  isShowLoader = false,
  isCheckRoute = false,
) => {
  let response;
  let _URL = URL;
  if (isCheckRoute) {
    _URL = getRoute(_URL);
  }
  // if (
  //   !instance?.defaults?.headers?.common?.Authorization &&
  //   (_URL.includes('v2/mybetsv3') || _URL.includes('v2/user/update')) &&
  //   !globalImport.isWeb
  // ) {
  //   // trackMoengageEvent('tokenCheck', {
  //   //   headers: instance?.defaults?.headers?.common?.Authorization
  //   //     ? true
  //   //     : false,
  //   //   screen: getCurrentRoute(),
  //   // });
  // }
  if (isShowLoader) {
    store.dispatch(setLoaderVisibility(true));
  }
  //const logedIn = await asyncStorage.getItem('userMobNumber');
  response = await instance.post(_URL, data, options).catch(function (err) {
    /*console.log(`errror code - ${JSON.stringify(err)}`);*/
    if (isShowLoader) {
      store.dispatch(setLoaderVisibility(false));
    }
    if (err.response?.status === 401) {
      const isLogin = instance?.defaults?.headers?.common?.Authorization;
      if (isLogin && !globalImport.isWeb) {
        // trackMoengageEvent('Logout Issue', {
        //   URL: URL,
        // });
        globalImport?.sentry?.captureException(new Error(URL));
      }
      logout();
      //}
    }
    /*console.log(`post request erro - ${JSON.stringify(err.response)}`);*/
    logAPIError('POST', _URL, data, err);
    return err.response;
  });
  logApi('POST', _URL, data, response);
  if (isShowLoader) {
    store.dispatch(setLoaderVisibility(false));
  }
  return response;
};

const PUT = async (_URL, data = null, options, isShowLoader = false) => {
  let response;
  if (isShowLoader) {
    store.dispatch(setLoaderVisibility(true));
  }
  //const logedIn = await asyncStorage.getItem('userMobNumber');
  response = await instance.put(_URL, data, options).catch(function (err) {
    /*console.log(`errror code - ${JSON.stringify(err)}`);*/
    if (isShowLoader) {
      store.dispatch(setLoaderVisibility(false));
    }
    if (err.response?.status === 401) {
      //if (logedIn) {
      logout();
      //}
    }
    /*console.log(`post request erro - ${JSON.stringify(err.response)}`);*/
    logAPIError('PUT', _URL, data, err);
    return err.response;
  });
  logApi('PUT', _URL, data, response);
  if (isShowLoader) {
    store.dispatch(setLoaderVisibility(false));
  }
  return response;
};

export {GET, POST, PUT};
